<template>
    <div>
        <div class="row text-center mt-2">
            <div class="col-sm-4 text-left align-self-center">{{ category.name }}</div>
            <div class="col-sm-2 align-self-center">
                <font-awesome-icon v-if="category.isActive" icon="toggle-on" class="mr-1"/>
                <font-awesome-icon v-else icon="toggle-off" class="mr-1"/>
            </div>
            <div class="col-sm-2 align-self-center">
                <font-awesome-icon v-if="category.isTemplate" icon="toggle-on" class="mr-1"/>
                <font-awesome-icon v-else icon="toggle-off" class="mr-1"/>
            </div>
            <div class="col-sm-4 d-flex justify-content-end align-self-center">
                <DocumentsManage v-if="hasExtraOptions()" :documents-data="category.documents" :category-id="category._id"/>
                <button class="ds-btn mr-1" @click="isModalVisible = true" v-b-tooltip.hover title="Apskatīt/Rediģēt">
                    <font-awesome-icon icon="eye"/>
                </button>
                <button v-if="!isTemplate && category.isTemplate"
                        class="ds-btn ds-btn--danger mr-1"
                        @click="handleCategoryTemplateClone"
                        v-b-tooltip.hover
                        title="Kopēt šablonu uzņēmumam">
                    <font-awesome-icon icon="clone"/>
                </button>
                <button v-if="hasMoreThanOneRequiredDoc() && currentUser.isAdmin && currentCompany._id.length"
                        class="ds-btn ds-btn--danger mr-1"
                        @click="handleCategoryTestReset"
                        v-b-tooltip.hover
                        title="Atjaunot lietotājiem testa rezultātus">
                    <font-awesome-icon icon="wrench"/>
                </button>
                <b-modal v-model="isModalVisible" no-close-on-backdrop hide-footer body-class="p-2"
                         header-class="bg-light align-items-center" size="lg">
                    <div slot="modal-title">
                        <h3 class="h4 text-dark font-weight-light m-0">{{ category.name }}</h3>
                    </div>
                    <div slot="modal-header-close">
                    </div>
                    <TemplateCategoriesBaseForm v-if="isTemplate" @finished="handleCategoryUpdate"
                                                :current-category="category"/>
                    <CategoriesBaseForm v-else @finished="handleCategoryUpdate" :current-category="category"/>
                </b-modal>
                <button v-if="hasExtraOptions()" class="ds-btn ds-btn--danger" @click="handleCategoryRemoval" v-b-tooltip.hover title="Dzēst">
                    <font-awesome-icon icon="trash"/>
                </button>
            </div>
        </div>
        <hr class="my-2"/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {Category} from '../../vuex/modules/category/models/category.models';
    import CategoriesBaseForm from './CategoriesBaseForm';
    import DocumentsManage from '../documents/DocumentsManage';
    import TemplateCategoriesBaseForm from './TemplateCategoriesBaseForm';
    import * as categoryStoreTypes from '../../vuex/modules/category/category.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types'
    import * as authStoreTypes from "../../vuex/modules/auth/auth.store-types";

    export default {
        name: 'categories-list-item',
        props: {
            category: {
                type: Category,
                required: true,
            }
        },
        components: {CategoriesBaseForm, TemplateCategoriesBaseForm, DocumentsManage},
        data: () => ({
            isModalVisible: false,
        }),
        computed: {
            ...mapGetters('category', {
                /** @type {function|*} */
                isActiveRequest: categoryStoreTypes.GET_IS_ACTIVE_REQUEST,
                /** @type {boolean|*} */
                isTemplate: categoryStoreTypes.GET_IS_TEMPLATE,
            }),
            ...mapGetters('company', {
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('category', {
                /** @type {function|*} */
                removeCategory: categoryStoreTypes.ACTION_REMOVE_CATEGORY,
                /** @type {function|*} */
                getCategories: categoryStoreTypes.ACTION_GET_CATEGORIES,
                /** @type {function|*} */
                updateCategory: categoryStoreTypes.ACTION_UPDATE_CATEGORY,
                /** @type {function|*} */
                updateCategoryRequiredTestResults: categoryStoreTypes.ACTION_UPDATE_CATEGORY_REQUIRED_TEST_RESULTS,
                /** @type {function|*} */
                cloneTemplateCategory: categoryStoreTypes.ACTION_CLONE_TEMPLATE_CATEGORY,
            }),
            async handleCategoryRemoval() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.removeCategory({category: this.category});

                    this.setAlertData({type: 'primary', message: 'Kateogrija izdzēsta!'});
                    this.getCategories({companyId: this.currentCompany._id});
                } catch (err) {
                    //
                }
            },
            async handleCategoryUpdate() {
                this.isModalVisible = false;
                this.getCategories({companyId: this.currentCompany._id});
            },
            async handleCategoryTestReset() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Atjaunot lietotāja testa rezultātus?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.updateCategoryRequiredTestResults({category: this.category});

                    this.setAlertData({type: 'primary', message: 'Testa rezultāti atjaunoti!'});
                } catch (err) {
                    //
                }
            },
             async handleCategoryTemplateClone() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Kopēt šablonu uzņēmumam? Veicot kopēšanu tiks pazaudēta saikne ar globālo kategoriju šablonu un lietotāju rezultāti tiks dzēsti!', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.cloneTemplateCategory({category: this.category, companyId: this.currentCompany._id});
                    
                    this.setAlertData({type: 'primary', message: 'Kateoriju šablons nokopēts!'});
                    this.getCategories({companyId: this.currentCompany._id});
                } catch (err) {
                    //
                }
            },
            hasExtraOptions() {
                return (!this.category.isTemplate && this.currentCompany._id.length)|| !this.currentCompany._id.length
            },
            hasMoreThanOneRequiredDoc() {
                return this.category.documents.filter(({isRequired}) => isRequired).length > 0;
            }
        },
    }
</script>